import React, { useContext } from 'react'
import { RevUserContext } from '../../context/UserContext';
import { useReduxDispatch, useReduxSelector } from '../../redux/hooks';
import { cancelMimic } from '../../slices/RevelationSlice';
import { IUserProfile } from '../../types/User/IUserProfile';

export const MimicBar = () => {
    const profile = useContext<IUserProfile>(RevUserContext)
    const mimicUid = useReduxSelector((state) => state.revI.mimicUid);
    const dispatch = useReduxDispatch();
    const cancelMimicSession = () => {
        dispatch(cancelMimic());
    };
    if (!mimicUid)
        return <></>

    return (
        <>
            <div className='mimic-bar'>You are currently mimicing user account&nbsp;<u>{profile.F_Name} {profile.L_Name}</u>. Press X to cancel this mimic session.
                <button className="k-font-icon k-i-close" title='Cancel mimic session' onClick={cancelMimicSession}>
                </button></div></>
    )
}
